import React, { useState, useEffect } from 'react';
import { Radio } from '@material-ui/core';
import css from '../../../styles/modules/PaymentFlow/radiobuttonbox.module.css';
import useWindowWidth from '../../../hooks/nonGQLhooks/useWindowWidth';

export default function RadioButtonBox({ content, checked, onChange }) {
  const windowWidth = useWindowWidth();

  return (
    <div>
      <div
        className="radio-button-box"
        style={{
          display: 'flex',
          alignItems: 'center',
          // gap: '0.52083333333vw',
          padding: '23px, 14px, 23px, 14px',
          margin: '10px',
          width: '270px',
          height: '89px',
          background: checked === content.id ? '#4566F1' : '#F6F6F6',
          border: `1px solid ${checked === content.id ? '#0C242D' : '#757D85'}`,
          boxShadow: '0px 2px 4px rgba(37, 57, 139, 0.1)',
          borderRadius: '6px',
          cursor: 'pointer',
        }}
        onClick={() => onChange(content.id)}
      >
        <Radio
          sx={{
            color: '#757D85',
            '&.Mui-checked': {
              color: 'white!important',
            },
            '& .MuiSvgIcon-root': {
              fontSize: 20,
            },
          }}
          key={content.id}
          id={content.id}
          type="radio"
          name="purposeType"
          checked={checked === content.id}
        />
        <span
          className={css.boxText}
          style={{ color: `${checked === content.id ? 'white' : '#757D85'}` }}
        >
          {content.label}
        </span>
      </div>
      {content.disclaimer && (
        <div style={{ width: '270px', margin: '0 10px' }}>
          {content.disclaimer}
        </div>
      )}
    </div>
  );
}
